import { render } from "./AdminLogin.vue?vue&type=template&id=185e5334&scoped=true&ts=true"
import script from "./AdminLogin.vue?vue&type=script&lang=ts"
export * from "./AdminLogin.vue?vue&type=script&lang=ts"

import "./AdminLogin.vue?vue&type=style&index=0&id=185e5334&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185e5334"]])

export default __exports__